// File: src/hooks/usePOTUSData.js
import { useState, useEffect } from 'react';
import axios from '../config/axiosConfig';

const usePOTUSData = () => {
  const [data, setData] = useState({
    schedule: [],
    executiveOrders: [],
    truthPosts: []
  });
  const [marketData, setMarketData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPOTUSData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await axios.get('/api/potus-data');
      
      if (response.data && response.data.data) {
        setData({
          schedule: response.data.data.schedule || [],
          executiveOrders: response.data.data.executiveOrders || [],
          truthPosts: response.data.data.truthPosts || []
        });
      }
    } catch (error) {
      console.error('Error fetching POTUS data:', error);
      setError('Failed to fetch POTUS data');
    } finally {
      setLoading(false);
    }
  };

  const fetchMarketPerformance = async () => {
    try {
      const response = await axios.get('/api/potus-market-performance');
      
      if (response.data && response.data.success && response.data.data) {
        setMarketData(response.data.data);
      } else {
        console.warn('Invalid market performance response format:', response.data);
        // Fallback to empty object if response format is unexpected
        setMarketData({});
      }
    } catch (error) {
      console.error('Error fetching market performance data:', error);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      // Run both API calls concurrently
      await Promise.all([
        fetchPOTUSData(),
        fetchMarketPerformance()
      ]);
    };

    loadData();
  }, []);

  const refreshData = () => {
    fetchPOTUSData();
    fetchMarketPerformance();
  };

  return {
    data,
    marketData,
    loading,
    error,
    refreshData
  };
};

export default usePOTUSData;